export default __webpack_public_path__ + "static/media/unzip-mac.374c77ce.webp";